/**
 * @file コンポーネント：フル動画ページスレッドポップアップ詳細ページ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { ModalThreadConfirm } from "~/src/components/pages/Video/Video/ModalThreadConfirm";
import { PopupThreadCard } from "~/src/components/pages/Video/Video/PopupThreadCard";
import { Button } from "~/src/components/uiparts/Button";
import { Pagination } from "~/src/components/uiparts/Pagination";
import { Paragraph } from "~/src/components/uiparts/Paragraph";
import { Select } from "~/src/components/uiparts/Select";
import { Textarea } from "~/src/components/uiparts/Textarea";

// スタイル読み込み
import {
    StyledCommentContents,
    StyledCommentContentsHeader,
    StyledCommentContentsHeaderText,
    StyledCommentList,
    StyledCommentListItem,
    StyledCommentNew,
    StyledCommentNewButtonlist,
    StyledCommentNewButtonlistItem,
    StyledCommentNewTextarea,
    StyledContainer,
    StyledNavigation,
    StyledSelectContainer,
    StyledThreadContent,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {props.isListReplyLoaded && (
                <StyledContainer ref={props.refContainer}>
                    {/* 削除確認モーダル */}
                    <ModalThreadConfirm
                        fnOnClickAgree={
                            !props.deleteReplyId
                                ? props.fnDeleteThread
                                : props.fnDeleteReply
                        }
                        fnOnClickCancel={
                            props.deleteReplyId && props.fnCancelDeleteReply
                        }
                        isOpenModalThreadConfirm={
                            props.isOpenModalThreadConfirm
                        }
                        paragraph={
                            localized[
                                !props.deleteReplyId
                                    ? "Message.ConfirmDeleteThread"
                                    : "Message.ConfirmCommentDelete"
                            ]
                        }
                        setIsOpenModalThreadConfirm={
                            props.setIsOpenModalThreadConfirm
                        }
                    />
                    {/* 成功、エラーメッセージ */}
                    {(props.messageDetail || props.errorMessageDetail) && (
                        <Paragraph
                            fontSize="xSmall"
                            onColor="gray"
                            paragraphType={
                                props.messageDetail ? "success" : "error"
                            }
                            text={
                                props.messageDetail
                                    ? props.messageDetail
                                    : props.errorMessageDetail
                            }
                        />
                    )}
                    {/* スレッド一覧に戻るボタン */}
                    <StyledNavigation>
                        <Button
                            buttonType="normal"
                            href="#"
                            icon={[
                                <i
                                    className="fas fa-chevron-left"
                                    key="icon-create"
                                ></i>,
                            ]}
                            onClick={(e) => {
                                e.preventDefault();
                                props.setCurrentPage("list");
                                props.fnClearMessage();
                            }}
                            text={localized["Label.ReturnToThreadList"]}
                        />
                    </StyledNavigation>
                    {/* スレッド */}
                    <StyledThreadContent>
                        <PopupThreadCard
                            commentUserName={props.selectedThread.userName}
                            currentPage={props.currentPage}
                            fnJump={props.fnJump}
                            handleClickDeleteButton={() => {
                                props.setIsOpenModalThreadConfirm(true);
                                props.fnClearMessage();
                            }}
                            handleClickEditButton={() => {
                                props.setCurrentPage("edit");
                                props.fnClearMessage();
                            }}
                            headline={props.selectedThread.title}
                            isOwner={props.selectedThread.isOwner}
                            passedTime={props.selectedThread.dateTimeAgo}
                            replyCount={props.selectedThread.replyCount}
                            text={props.fnEscapeHtml(
                                props.selectedThread.context
                            )}
                        />
                    </StyledThreadContent>
                    <StyledCommentContents>
                        <StyledCommentContentsHeader>
                            {/* 返信コメント見出し */}
                            <StyledCommentContentsHeaderText>
                                {localized["Label.ReplyComments"] +
                                    " (" +
                                    props.replyCount +
                                    ")"}
                            </StyledCommentContentsHeaderText>
                            {/* 返信コメントのソートセレクトボタン */}
                            {props.listReply && (
                                <StyledSelectContainer
                                    onClick={() => props.fnClearMessage()}
                                >
                                    <Select
                                        list={[
                                            {
                                                text: localized[
                                                    "Label.LatestReply"
                                                ],
                                                value: "createDesc",
                                            },
                                            {
                                                text: localized[
                                                    "Label.OldestReply"
                                                ],
                                                value: "createAsc",
                                            },
                                            {
                                                text: localized[
                                                    "Label.RatingCountReply"
                                                ],
                                                value: "ratingCount",
                                            },
                                        ]}
                                        onChange={(e) =>
                                            props.fnChangeSortType(e)
                                        }
                                        onColor="gray"
                                    />
                                </StyledSelectContainer>
                            )}
                        </StyledCommentContentsHeader>
                        {/* コメント */}
                        {props.listReply ? (
                            <>
                                {/* ページング */}
                                <Pagination
                                    list={props.replyPaginationlist}
                                    onColor="white"
                                />
                                {/* コメント一覧 */}
                                <StyledCommentList>
                                    {props.listReply?.map((reply) => (
                                        <StyledCommentListItem
                                            key={"reply-" + reply.threadReplyId}
                                        >
                                            <PopupThreadCard
                                                commentUserName={reply.userName}
                                                currentPage={props.currentPage}
                                                fnJump={props.fnJump}
                                                handleClickDeleteButton={() => {
                                                    props.setDeleteReplyId(
                                                        reply.threadReplyId
                                                    );
                                                    props.setIsOpenModalThreadConfirm(
                                                        true
                                                    );
                                                    props.fnClearMessage();
                                                }}
                                                handleClickEditButton={() => {
                                                    props.fnOnClickReplyEditButton(
                                                        reply,
                                                        props.selectedReply
                                                            ? props
                                                                  .selectedReply
                                                                  .threadReplyId ===
                                                                  reply.threadReplyId
                                                            : false
                                                    );
                                                    props.fnClearMessage();
                                                }}
                                                handleClickRatingsButton={() => {
                                                    props.fnRateReply(
                                                        reply.threadReplyId
                                                    );
                                                    props.fnClearMessage();
                                                }}
                                                isEditReply={
                                                    props.selectedReply
                                                        ? props.selectedReply
                                                              .threadReplyId ===
                                                          reply.threadReplyId
                                                        : false
                                                }
                                                isOwner={reply.isOwner}
                                                isRating={reply.isRating}
                                                passedTime={reply.dateTimeAgo}
                                                ratingCount={reply.ratingCount}
                                                text={reply.context}
                                            />
                                        </StyledCommentListItem>
                                    ))}
                                </StyledCommentList>
                                {/* ページング */}
                                <Pagination
                                    list={props.replyPaginationlist}
                                    onColor="white"
                                />
                            </>
                        ) : (
                            <>
                                {/* 返信コメントが無い場合のメッセージ */}
                                <Paragraph
                                    onColor="white"
                                    text={localized["Label.NoReplyComment"]}
                                />
                            </>
                        )}
                    </StyledCommentContents>
                    <StyledCommentNew
                        className={props.selectedReply && "is-edit"}
                    >
                        {/* 返信コメントテキストエリア */}
                        <StyledCommentNewTextarea
                            onClick={() => props.fnClearMessage()}
                        >
                            <Textarea
                                id="commentText"
                                isWide={true}
                                maxlength="1024"
                                name="commentText"
                                placeholder={localized["Label.AddAComment"]}
                                refTextarea={props.refTextareaReply}
                                rows="3"
                            />
                        </StyledCommentNewTextarea>
                        <StyledCommentNewButtonlist>
                            {/* 動画の再生時間追加ボタン */}
                            <StyledCommentNewButtonlistItem>
                                <Button
                                    buttonType="sub"
                                    href="#"
                                    isFullHeight={true}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.fnAddTimelineEditReply();
                                        props.fnClearMessage();
                                    }}
                                    text={localized["Label.AddTimeline"]}
                                />
                            </StyledCommentNewButtonlistItem>
                            {/* 返信コメント投稿、更新ボタン */}
                            <StyledCommentNewButtonlistItem>
                                <Button
                                    buttonType="submit"
                                    href="#"
                                    icon={[
                                        !props.selectedReply ? (
                                            <i
                                                className="fas fa-reply"
                                                key="icon-create"
                                            ></i>
                                        ) : (
                                            <i
                                                className="fas fa-pen"
                                                key="icon-edit"
                                            ></i>
                                        ),
                                    ]}
                                    isFullHeight={true}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.fnNewEditReply(
                                            !props.selectedReply
                                                ? "POST"
                                                : "PUT"
                                        );
                                    }}
                                    text={
                                        localized[
                                            !props.selectedReply
                                                ? "Label.Reply"
                                                : "Label.Update"
                                        ]
                                    }
                                />
                            </StyledCommentNewButtonlistItem>
                        </StyledCommentNewButtonlist>
                    </StyledCommentNew>
                </StyledContainer>
            )}
        </>
    );
};
